import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: "history", //路由模式
  base: "/points-official-website", //部署的子路径

  routes: [{
      path: '/',
      redirect: '/index'
    },

    //访问home时，重定向到wellcome页
    {
      path: '/index',
      name: 'index',
     component: () => import('@/view/index'),
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/view/login'),
      meta: { full: true }
    },
    {
      path: '/game',
      name: 'game',
      component: () => import('@/view/game/game'),
    },
    {
      path: '/gameDetail',
      name: 'gameDetail',
      component: () => import('@/view/game/gameDetail'),
    },
    {
      path: '/player',
      name: 'player',
      component: () => import('@/view/player'),
    },
    {
      path: '/news',
      name: 'news',
      component: () => import('@/view/news/news'),
    },
    {
      path: '/newsDetail',
      name: 'newsDetail',
      component: () => import('@/view/news/newsDetail'),
    },
    {
      path: '/describe',
      name: 'describe',
      component: () => import('@/view/describe'),
    },
    {
      path: '/myInfo',
      name: 'myInfo',
      component: () => import('@/view/user/myInfo'),
    },
    {
      path: '/playerInfo',
      name: 'playerInfo',
      component: () => import('@/view/user/playerInfo'),
    },
    {
      path: '*',
      name: '404',
      component: () => import('@/view/404'),
      meta: { full: true }
    },
  ]
})


export default router

//防止报路由重复
  const originalPush = VueRouter.prototype.push
  VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
  }



// WEBPACK FOOTER //
// ./src/router/index.js